import {Card} from "antd";
import "./grid-filter-card.css";

/**
 * Az alanlı grid filtreleri için yan panelin yerine grid kartının ÜSTÜNDE duran ayrı kart.
 *
 * İçindeki form şu class'ları taşımalı:
 *  - `grid-filter-form`: select taşma düzeltmesi (grid-filter.css) ve detay çekmecesinin
 *    "dışarı tıklayınca kapan" kuralındaki istisna (bkz. useRowDetailDrawer).
 *  - `grid-filter-inline`: alanlar yan yana dizilir, sığmayan alt satıra geçer.
 * Ara/Sıfırla düğmeleri formun sonunda `<Form.Item className={'grid-filter-actions'}>` içinde durur;
 * bu öğe tam satır genişliğinde olduğu için düğmeler her zaman kartın sol altına düşer.
 */
export default function GridFilterCard({children}) {
    return (
        <Card size={'small'} className={'grid-filter-card'}>
            {children}
        </Card>
    )
}
